import { createApiSaga } from "redux-store/api-sagas";
import { baseService } from "service/base";

import { FETCH_PARAM_MAPPINGS } from "./actions";

const paramMappingsSaga = createApiSaga({
  fetchAction: FETCH_PARAM_MAPPINGS,
  service: () => {
    return baseService.get("/api/params/legacy");
  },
  serviceName: "loadParamMappings",
});

export { paramMappingsSaga };
